import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-deck-communication',
  templateUrl: './card-deck-communication.component.html',
  styleUrls: ['./card-deck-communication.component.scss']
})
export class CardDeckCommunicationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
